import http from '@/utils/http';
import type { MutationTree, ActionTree, GetterTree } from 'vuex'
import type { State } from '../index'

interface Infos {
  [index: string]: unknown
}

export interface MindsState {
  wordInfos: Infos,
  selectedNodeID:string,
  wordFullForm:string
}

const state: MindsState = {
  wordInfos: {},
  selectedNodeID:"",
  wordFullForm:""
};

const mutations: MutationTree<MindsState> = {
  updateWordInfos(state, payload){
    state.wordInfos = payload;
  },
  updateSelectedNodeID(state, payload){
    state.selectedNodeID = payload;
  },
  updateWordFullForm(state, payload){
    state.wordFullForm = payload;
  }
};

const actions: ActionTree<MindsState, State> = {
  queryWordExplain(context, payload){
    return http.post('/search/user/searchWordRedis', payload);
  },

  queryMind(context, payload){
    return http.post('/search/user/searchMind', payload);
  },

  queryExplain(context, payload){
    return http.post('/search/user/searchMindsExplain', payload);
  },
};
const getters: GetterTree<MindsState, State> = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}